import { Typography } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { EmptyValue, isEmptyValue } from "./requested-field-value-empty"

/**
 * Read-only display of a `text` requested field's answer. Plain text, with the shared muted placeholder
 * when the recipient left it blank. Counterpart of `text-field-input.js` on the reviewer's responses
 * tab.
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 * @param {string} [props.value]
 */
export function TextFieldValue({ value }) {
    return (
        <If value={!isEmptyValue(value)}>
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                {value}
            </Typography>
            <Else>
                <EmptyValue />
            </Else>
        </If>
    )
}
